"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateField = DateField;
var _react = _interopRequireWildcard(require("react"));
var _datepicker = require("@react-aria/datepicker");
var _datepicker2 = require("@react-stately/datepicker");
var _date = require("@internationalized/date");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../../shared/global-tokens");
var _input = require("../../../inputs/input/input.tokens");
var _reactAria = require("react-aria");
var _tokens = _interopRequireDefault(require("../../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var StyledDateField = _styledComponents.default.div.withConfig({
  displayName: "DateField__StyledDateField",
  componentId: "sc-sat0nf-0"
})(["display:inline-flex;box-sizing:border-box;padding:", ";&:first-of-type{padding:", ";}position:relative;left:-1px;border:2px solid transparent;&:focus-visible,&:has(:focus){border-radius:4px;outline:2px solid ", ";outline-offset:-2px;border-color:transparent;}"], _input.tokens.padding.leftAndRightIcon, _input.tokens.padding.rightIcon, _tokens.default.sky.sys.color.border.focusring);
var StyledDateSegment = _styledComponents.default.div.withConfig({
  displayName: "DateField__StyledDateSegment",
  componentId: "sc-sat0nf-1"
})(["box-sizing:content-box;text-align:center;", ";color:", ";&:focus-visible{outline-color:", ";outline-offset:-2px;border-color:transparent;}min-width:", ";"], _tokens.default.sky.sys.font.body['1'], _globalTokens.globalColor.text.content.main, _tokens.default.sky.sys.color.border.focusring, function (_ref) {
  var maxLength = _ref.maxLength;
  return maxLength ? maxLength + 'ch' : 'auto';
});
var Placeholder = _styledComponents.default.span.withConfig({
  displayName: "DateField__Placeholder",
  componentId: "sc-sat0nf-2"
})(["visibility:", ";height:", ";pointer-events:none;display:block;"], function (_ref2) {
  var show = _ref2.show;
  return show ? '' : 'hidden';
}, function (_ref3) {
  var show = _ref3.show;
  return show ? '' : 0;
});
var getSegmentMaxLength = function getSegmentMaxLength(maxValue) {
  return maxValue != null ? String(maxValue).length : undefined;
};
function DateField(_ref4) {
  var _ref4$dataCy = _ref4['data-cy'],
    dataCy = _ref4$dataCy === void 0 ? 'date-field' : _ref4$dataCy,
    _ref4$label = _ref4.label,
    label = _ref4$label === void 0 ? 'Date' : _ref4$label,
    ariaProps = _objectWithoutProperties(_ref4, ['data-cy', "label"]);
  var _ref6 = (0, _reactAria.useLocale)(),
    locale = _ref6.locale;
  var ariaState = (0, _datepicker2.useDateFieldState)(_objectSpread({}, ariaProps, {
    locale: locale,
    createCalendar: _date.createCalendar
  }));
  var ref = (0, _react.useRef)(null);
  var dateFieldAria = (0, _datepicker.useDateField)(_objectSpread({}, ariaProps, {
    label: label
  }), ariaState, ref);
  var fieldProps = dateFieldAria.fieldProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDateField, _objectSpread({}, fieldProps, {
    ref: ref,
    tabIndex: 0,
    children: ariaState.segments.map(function (segment, i) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(DateSegment, {
        segment: segment,
        ariaState: ariaState,
        "data-cy": "".concat(dataCy, "-").concat(segment.type),
        tabIndex: -1
      }, i);
    })
  }));
}
function DateSegment(_ref5) {
  var segment = _ref5.segment,
    ariaState = _ref5.ariaState,
    dataCy = _ref5['data-cy'],
    tabIndex = _ref5.tabIndex;
  var ref = (0, _react.useRef)(null);
  var _ref7 = (0, _datepicker.useDateSegment)(segment, ariaState, ref),
    segmentProps = _ref7.segmentProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDateSegment, _objectSpread({}, segmentProps, {
    "data-cy": dataCy,
    ref: ref,
    isEditable: segment.isEditable,
    maxLength: getSegmentMaxLength(segment.maxValue),
    tabIndex: tabIndex,
    children: segment.isPlaceholder ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Placeholder, {
      "aria-hidden": "true",
      show: segment.isPlaceholder,
      children: segment.placeholder
    }) : segment.text
  }));
}